module.exports = __webpack_public_path__ + "img/sprite.497f797e.svg";